<template>
    <div>
        <b-row>
            <b-col sm="6" md="3" v-if="$can('manage base_thunder')">
                <router-link to="/admin/thunder">
                    <b-card class="tool">
                        <i class="icon-energy" /> <br />
                        <h5>{{ $t('thunder') }}</h5> 
                        <small> {{ $t('collectionData') }} </small>
                    </b-card>
                </router-link>
            </b-col>

            <b-col sm="6" md="3"  v-if="$can('manage base_sparks')">
                <b-card class="tool" v-if="!account.sparks">
                    <i class="icon-fire" /> <br />
                        <div><h5>{{ $t('spark') }}
                            <protokol-tooltip id="sparkNotAvailableDesc" variant="warning"> 
                                    <template #icon>!</template>
                                    <template #content>
                                        {{ $t('functionalityNotAvailableOnAccount') }}
                                    </template>
                                </protokol-tooltip>
                        </h5> </div> 
                        <small>{{ $t('serverless') }}</small> <br />
                </b-card>
                <router-link to="/admin/spark" v-else>
                    <b-card class="tool" disabled>
                        <i class="icon-fire" /> <br />
                        <div><h5>{{ $t('spark') }}</h5> <b-badge variant="primary"> beta </b-badge> </div> 
                        <small>{{ $t('serverless') }}</small> <br />
                    </b-card>
                </router-link>
            </b-col>

            <b-col sm="6" md="3"  v-if="$can('manage base_functions')">
                <router-link to="/admin/functions">
                    <b-card class="tool" disabled>
                        <b-icon icon="code" /> <br />
                        <div><h5>{{ $t('functions.title') }}</h5> </div> 
                        <small>{{ $t('platformFunctionsDeveloperDescription') }}</small> <br />
                    </b-card>
                </router-link>
            </b-col>

            <b-col sm="6" md="3"  v-if="$can('manage base_public_apps')">
                <b-card class="tool" v-if="!account.public_apps">
                        <b-icon icon="tablet" /> <br />
                        <div><h5>{{ $t('publicapp') }}
                            <protokol-tooltip id="publicAppNotAvailableDesc" variant="warning"> 
                                    <template #icon>!</template>
                                    <template #content>
                                        {{ $t('functionalityNotAvailableOnAccount') }}
                                    </template>
                                </protokol-tooltip>
                        </h5> </div> 
                        <small>{{ $t('managePublicApps') }}</small> <br />
                </b-card>
                <router-link to="/admin/public-app" v-else>
                    <b-card class="tool">
                        <b-icon icon="tablet" /> <br />
                        <div><h5>{{ $t('publicapp') }}</h5></div> 
                        <small>{{ $t('managePublicApps') }}</small>
                    </b-card>
                </router-link>
            </b-col>
            <b-col sm="6" md="3"  v-if="$can('manage base_platform_apps')">
                <b-card class="tool" v-if="!account.platform_apps">
                        <b-icon icon="window" /> <br />
                        <div><h5>{{ $t('platformapp') }}
                            <protokol-tooltip id="platformAppNotAvailableDesc" variant="warning"> 
                                    <template #icon>!</template>
                                    <template #content>
                                        {{ $t('functionalityNotAvailableOnAccount') }}
                                    </template>
                                </protokol-tooltip>
                        </h5> </div> 
                        <small>{{ $t('managePlatformApps') }}</small> <br />
                </b-card>
                <router-link to="/admin/app" v-else>
                    <b-card class="tool">
                        <b-icon icon="window" /> <br />
                        <div><h5>{{ $t('platformapp') }}</h5></div> 
                        <small>{{ $t('managePlatformApps') }}</small>
                    </b-card>
                </router-link>
            </b-col>
            <b-col sm="6" md="3"  v-if="$can('manage base_ratchet')">
                <router-link to="/admin/ratchet">
                    <b-card class="tool">
                        <img src="/img/developer/ratchet.png" width="25" /> <br />
                        <div><h5>Ratchet</h5> </div> 
                        <small>{{ $t('ratchetDescription') }}</small>
                    </b-card>
                </router-link>
            </b-col>

            <b-col sm="6" md="3"  v-if="$can('manage base_workflows')">
                <router-link to="/admin/scout/workflow">
                    <b-card class="tool">
                        <i class="icon-share" /> <br />
                        <h5>{{ $t('workflow.title') }} </h5>
                        <small>{{ $t('debugWorkflows') }}</small>
                    </b-card>
                </router-link>
            </b-col>
            
            <b-col sm="6" md="3"  v-if="$can('manage base_platform_env')">
                <router-link to="/admin/environment">
                    <b-card class="tool">
                        <i class="bi bi-braces-asterisk" /> <br />
                        <h5>{{ $t('globalEnvironment') }} </h5>
                        <small>{{ $t('globalEnvironmentDesc') }}</small>
                    </b-card>
                </router-link>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    computed: {
        account() {
            return this.$store.getters.getAccount
        }
    }
}
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
}

.tool {
    text-align: center;
    cursor: pointer;
    font-size: 20px;

    .notAvailable {
        font-size: 12px;
    }

    small {
        font-size: 12px;
        color: #ccc;
    }

    &.coming-soon {
        color: #ccc;
        border-color: #ccc;
    }

    .icon-fire {
        color: orange;
    }

    .icon-energy {
        color: yellow;
    }
}
</style>
